import isEqual from 'lodash/isEqual';
import { createStore, combineReducers } from 'redux';

import { layersAst } from '@/features/editor/editor-state/state/layers-ast.slice';
import { navigationAst } from '@/features/editor/editor-state/state/navigation-ast.slice';
import { liveLayer } from '@/features/editor/live-layer/state/live-layer.slice';
import { themeAst } from '@/features/editor/panels/theme-panel/state/theme-ast.slice';
import { i18n } from '@/features/editor/workspaces/i18n/state/i18n.slice';
import { releaseReducers } from '@/features/editor/workspaces/versions/state/versions.slice';
import { orgs } from '@/features/org/state/orgs.slice';

/* ────────────────────────────────────────────────────────────────────────── */
/* AST-derived slices now live one-per-file under redux/. This module is the   */
/* store factory plus a back-compat barrel so existing                          */
/* `import { … } from '@/store/createStore'` call sites keep working.          */
/* ────────────────────────────────────────────────────────────────────────── */

export type { RootState } from '@/store/rootState';
export {
  type ThemeAstState,
  type ThemeAstAction,
  setThemeAst,
  selectThemeAst,
} from '@/features/editor/panels/theme-panel/state/theme-ast.slice';
export {
  type LayerNode,
  type LayersAstState,
  type LayersAstAction,
  setLayersAst,
} from '@/features/editor/editor-state/state/layers-ast.slice';
export {
  type NavigationAstState,
  type NavigationAstAction,
  setNavigationAst,
} from '@/features/editor/editor-state/state/navigation-ast.slice';
export {
  type LiveLayerBinding,
  type LiveLayerState,
  type LiveLayerAction,
  setLiveLayerSchema,
  setLiveLayerTaxonomy,
  setLiveLayerBindings,
  selectLiveLayerSchema,
  selectLiveLayerSchemaError,
  selectLiveLayerSchemaSynced,
  selectLiveLayerTaxonomy,
  selectLiveLayerBindings,
} from '@/features/editor/live-layer/state/live-layer.slice';
export {
  type I18nState,
  type I18nAction,
  setI18n,
  selectI18n,
  selectI18nSynced,
  selectI18nError,
} from '@/features/editor/workspaces/i18n/state/i18n.slice';

/* ── Misc top-level reducers (no AST) ──────────────────────────────── */

function viewer(state: any = null, action: any) {
  switch (action.type) {
    case 'UPDATE_VIEWER':
      return isEqual(state, action.viewer) ? state : action.viewer;
    default:
      return state;
  }
}

function splitTestSettings(state: any = {}, action: any) {
  switch (action.type) {
    default:
      return state;
  }
}

/* ── Store factory ─────────────────────────────────────────────────── */

export default function createStoreWithPreloadedState(state: any) {
  return createStore(
    combineReducers({
      viewer,
      splitTestSettings,
      themeAst,
      layersAst,
      navigationAst,
      liveLayer,
      i18n,
      orgs,
      ...releaseReducers,
    }),
    state,
  );
}
